import { Component, OnInit, ViewChild, ElementRef, asNativeElements } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { TraductorService } from '../../servicios/traductor.service';
import * as InfoV from '../../../assets/JsonEstructura/video.json';
import { Video } from '../../Models/video.model';

// import { getElementDepthCount } from '@angular/core/src/render3/state';

declare var $: any;

const dataI = JSON.stringify(InfoV);
const dataIn = JSON.parse(dataI);


@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.css'],

})
export class GaleriaComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  public suscribe: Subscription;

  public data: any;
  public modeloVideo: any;
  public modeloVideoIn: any;
  public modeloVideoZh: any;
  public modeloVideoFr: any;
  public modeloVideoDe: any;
  public modeloVideoRu: any;
  public modeloVideoBr: any;
  public modeloVideoKr: any;
  
  public clic: any;
  public getURL: string;
  public safeURL: SafeResourceUrl;
  public videoDescripcion: any;
  public videoDescripcionIn: any;
  public videoDescripcionZh: any;
  public videoDescripcionFr: any;
  public videoDescripcionDe: any;
  public videoDescripcionRu: any;
  public videoDescripcionBr: any;
  public videoDescripcionKr: any;
  public idioma: string = "";

  public etiquetas: any;
  public etiquetasIn: any;
  public etiquetasZh: any;
  public etiquetasFr: any;
  public etiquetasDe: any;
  public etiquetasRu: any;
  public etiquetasBr: any;
  public etiquetasKr: any;


  constructor(
    private _sanitizer: DomSanitizer,
    private _traductorService: TraductorService
  ) {

    this.idioma = localStorage.getItem("idioma")


    this.suscribe = this._traductorService.getEvento().subscribe({
      next: result => {
        if (result) {
          if (result == 2) {
            this.idioma = "2"
            localStorage.setItem("idioma", this.idioma);
          } else if (result == 3) {
            this.idioma = "3"
            localStorage.setItem("idioma", this.idioma);
          } else if (result == 4) {
            this.idioma = "4"
            localStorage.setItem("idioma", this.idioma);
          } else if (result == 5) {
            this.idioma = "5"
            localStorage.setItem("idioma", this.idioma);
          } else if (result == 6) {
            this.idioma = "6"
            localStorage.setItem("idioma", this.idioma);
          }else if (result == 7) {
            this.idioma = "7"
            localStorage.setItem("idioma", this.idioma);
          }else if (result == 8) {
            this.idioma = "8"
            localStorage.setItem("idioma", this.idioma);
          }
        }
      },
      error: error => {
        console.log(error);

      }
    })

    this.data = new Array(dataIn);
    this.modeloVideo = new Video("", "", "", "", "");
    this.modeloVideoIn = new Video("", "", "", "", "");
    this.modeloVideoZh = new Video("", "", "", "", "");
    this.modeloVideoFr = new Video("", "", "", "", "");
    this.modeloVideoDe = new Video("", "", "", "", "");
    this.modeloVideoRu = new Video("", "", "", "", "");
    this.modeloVideoBr = new Video("", "", "", "", "");
    this.modeloVideoKr = new Video("", "", "", "", "");
    
    this.videoDescripcion = new Video("", "", "", "", "");
    this.videoDescripcionIn = new Video("", "", "", "", "");
    this.videoDescripcionZh = new Video("", "", "", "", "");
    this.videoDescripcionFr = new Video("", "", "", "", "");
    this.videoDescripcionDe = new Video("", "", "", "", "");
    this.videoDescripcionRu = new Video("", "", "", "", "");
    this.videoDescripcionBr = new Video("", "", "", "", "");
    this.videoDescripcionKr = new Video("", "", "", "", "");
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/zpOULjyy-n8?rel=0");

  }

  ngOnInit() {

    for (let i = 0; i < this.data[0].default.Titulos.length; i++) {
      this.etiquetas = new Video(this.data[i].default.Titulos[i].titulo1, this.data[i].default.Titulos[i].ListaTitulo, this.data[i].default.Titulos[i].autorTitulo, this.data[i].default.Titulos[i].descripcionTitu, this.data[i].default.Titulos[i].descargaBo);
      this.etiquetasIn = new Video(this.data[i].default.Titulos[i].titulo1In, this.data[i].default.Titulos[i].ListaTituloIn, this.data[i].default.Titulos[i].autorTituloIn, this.data[i].default.Titulos[i].descripcionTituIn, this.data[i].default.Titulos[i].descargaBoIn);
      this.etiquetasZh = new Video(this.data[i].default.Titulos[i].titulo1Zh, this.data[i].default.Titulos[i].ListaTituloZh, this.data[i].default.Titulos[i].autorTituloZh, this.data[i].default.Titulos[i].descripcionTituZh, this.data[i].default.Titulos[i].descargaBoZh);
      this.etiquetasFr = new Video(this.data[i].default.Titulos[i].titulo1Fr, this.data[i].default.Titulos[i].ListaTituloFr, this.data[i].default.Titulos[i].autorTituloFr, this.data[i].default.Titulos[i].descripcionTituFr, this.data[i].default.Titulos[i].descargaBoFr);
      this.etiquetasDe = new Video(this.data[i].default.Titulos[i].titulo1De, this.data[i].default.Titulos[i].ListaTituloDe, this.data[i].default.Titulos[i].autorTituloDe, this.data[i].default.Titulos[i].descripcionTituDe, this.data[i].default.Titulos[i].descargaBoDe);
      this.etiquetasRu = new Video(this.data[i].default.Titulos[i].titulo1Ru, this.data[i].default.Titulos[i].ListaTituloRu, this.data[i].default.Titulos[i].autorTituloRu, this.data[i].default.Titulos[i].descripcionTituRu, this.data[i].default.Titulos[i].descargaBoRu);
      this.etiquetasBr = new Video(this.data[i].default.Titulos[i].titulo1Br, this.data[i].default.Titulos[i].ListaTituloBr, this.data[i].default.Titulos[i].autorTituloBr, this.data[i].default.Titulos[i].descripcionTituBr, this.data[i].default.Titulos[i].descargaBoBr);
      this.etiquetasKr = new Video(this.data[i].default.Titulos[i].titulo1Kr, this.data[i].default.Titulos[i].ListaTituloKr, this.data[i].default.Titulos[i].autorTituloKr, this.data[i].default.Titulos[i].descripcionTituKr, this.data[i].default.Titulos[i].descargaBoKr);
    }

  }
  getUrl(clic: any) {
    this.clic = clic;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.data[0].default.video.length; i++) {
      if (this.data[0].default.video[i].id == this.clic) {
        this.getURL = this.data[0].default.video[i].URL;
        //***********************************************************************Modelo de idiomas nombre*****************************************************************
        // tslint:disable-next-line:max-line-length
        this.modeloVideo = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreV, "", "", "");
        this.modeloVideoIn = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVIn, "", "", "");
        this.modeloVideoZh =  new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVZh, "", "", "");
        this.modeloVideoFr = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVFr, "", "", "");
        this.modeloVideoDe = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVDe, "", "", "");
        this.modeloVideoRu = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVRu, "", "", "");
        this.modeloVideoBr = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVBr, "", "", "");
        this.modeloVideoKr = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].nombreVKr, "", "", "");
        console.log(this.videoDescripcionFr)
        //***********************************************************************Modelo de idiomas Nombre*****************************************************************
        // tslint:disable-next-line:max-line-length
        this.videoDescripcion = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracion, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcion, this.data[0].default.video[i].fechaP);
        this.videoDescripcionIn = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionIn, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionIn, this.data[0].default.video[i].fechaP);
        this.videoDescripcionZh = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionZh, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionZh, this.data[0].default.video[i].fechaP);
        this.videoDescripcionFr = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionFr, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionFr, this.data[0].default.video[i].fechaP);
        this.videoDescripcionDe = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionDe, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionDe, this.data[0].default.video[i].fechaP);
        this.videoDescripcionRu = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionRu, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionRu, this.data[0].default.video[i].fechaP);
        this.videoDescripcionBr = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionBr, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionBr, this.data[0].default.video[i].fechaP);
        this.videoDescripcionKr = new Video(this.data[0].default.video[i].id, this.data[0].default.video[i].duracionKr, this.data[0].default.video[i].autor, this.data[0].default.video[i].descripcionKr, this.data[0].default.video[i].fechaP);
        //***********************************************************************Reproduccion de video *******************************************************************
        this.videoplayer.nativeElement.play();
        this.videoplayer.nativeElement.src = this.getURL;


      }
    }
  }
}
